/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Offer, PriceRequest, ProductExtra } from 'rest-client';

import { OfferStateModel } from '@app/modules/core/states/offer-state/offer.model';

import { AbsuidService } from '../services/absuid/absuid.service';
import { TripStateModel } from '../states/trip-state/trip.model';

const TYPE_WASH = 'wash';
const SERVICE_TYPE_SPACE = '2';

export function getOfferParams(
  offerData: OfferStateModel,
  absuidService?: AbsuidService,
  tripData?: TripStateModel,
): PriceRequest {
  const offer = offerData?.offer;
  const priceRequest = new PriceRequest();
  priceRequest.endDate = new Date(offerData?.offer?.endDate);
  priceRequest.startDate = new Date(offerData?.offer?.startDate);
  priceRequest.productId = offerData?.offer?.productId;
  priceRequest.id_wash_extra = getIdWashExtra(offer?.extras);
  priceRequest.id_space_extra = getIdSpaceExtra(offer?.extras);
  priceRequest.id_mechanical_estimate = getIdMechanicalEstimate(offer);
  priceRequest.use_points = getIfUsePoints(offer);
  priceRequest.promoCode = getIfPromoCode(offer);

  if (absuidService) {
    priceRequest.step = absuidService.getTestParams().step;
  }
  if (tripData) {
    priceRequest.ship = tripData.flight_number
      ? tripData.flight_number
      : tripData.ship ?? null;
    priceRequest.in_passengers = tripData.in_passengers ?? null;
    priceRequest.out_passengers = tripData.out_passengers ?? null;
    priceRequest.in_terminal = tripData.in_terminal ?? null;
    priceRequest.trip = { in_terminal: tripData.in_terminal ?? null };
  }
  return priceRequest;
}

export function getIdWashExtra(extras: ProductExtra[]): number {
  return extras.find((extra: ProductExtra) => extra.type === TYPE_WASH)?.id;
}

export function getIdSpaceExtra(extras: ProductExtra[]): number {
  return extras.find(
    (extra: ProductExtra) => extra.service_type === SERVICE_TYPE_SPACE
  )?.id;
}

export function getIfUsePoints(offer: Offer): boolean {
  return offer.pvp_product_points > 0;
}

export function getIfPromoCode(offer: Offer): string {
  if (!!offer.promos.length) {
    return offer.promos[0].code;
  }
  return null;
}

export function getIdMechanicalEstimate(offer: Offer): number {
  if (
    offer.mechanical_orders &&
    offer.mechanical_orders.length &&
    offer.mechanical_orders?.[0].id_mechanical_estimate
  ) {
    const mechanical_orders = offer.mechanical_orders;
    return mechanical_orders?.[0].id_mechanical_estimate;
  } else {
    return null;
  }
}
